export default {
  campaignBanners: state => state.campaignBanners,
  campaignBannerInfos: state => state.campaignBannerInfos,
  totalPages: state => state.totalPages,
  socketListened: state => state.socketListened,
  chosenBanner: state => state.chosenBanner,
  lastNews: state => state.lastNews,
}
